import { useState, useEffect } from "react";
import { useHistory } from "react-router";
import SelectField from "../../../../components/ui/basicSelectInput";
import { ValidatorForm } from "react-material-ui-form-validator";
import { Grid } from "@material-ui/core";
import BasicInputField from "../../../../components/ui/basicInput";
import axios from "../../../../axios-order";
import designForGstr2b from "../GSTR2B_reconciliation/Gstr2bReconciliation.module.css";
import ValidatedDatePicker from "../../../../components/ui/monthWiseDatePicker";
import ValidatedMonthAndYearPicker from "../../../../components/ui/monthWiseDatePicker";
import CryptoJS from "crypto-js";
import Modal from "react-bootstrap/Modal";
import Checkbox from "@mui/material/Checkbox";
import { IconButton, Tooltip } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CircularProgress from "@material-ui/core/CircularProgress";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

import { useRef } from "react";
import { generateUUID } from '../../../../utils/sseUtils';
import { SSE_BASE_URL } from '../../../../axios-order';

export default function Gstr6aReconciliation() {
  const history = useHistory();
  const [openAndCloseModel, setOpenAndCloseModel] = useState(false);
  const [fromMonthAndYear, setFromMonthAndYear] = useState("");
  const [toMontAndYear, setToMontAndYear] = useState("");
  const [forDisplayingFromMonthAndYear, setForDisplayingFromMonthAndYear] =
    useState("");
  const [forDisplayingToMonthAndYear, setForDisplayingToMonthAndYear] =
    useState("");
  const [roundValue, setRoundValue] = useState(0);
  const [customRoundOff, setCustomRoundOff] = useState("");
  const [trigarCustomRoundOff, setTrigarCustomRoundOff] = useState(false);

  const [loaderForTable, setLoaderForTable] = useState(false);

  const [checked, setChecked] = useState(false);
  const [
    forDisplayingFromMonthAndYearGSTR,
    setForDisplayingFromMonthAndYearGSTR,
  ] = useState("");
  const [forDisplayingToMonthAndYearGSTR, setForDisplayingToMonthAndYearGSTR] =
    useState("");
  const [fromMonthAndYearGSTR, setFromMonthAndYearGSTR] = useState("");
  const [toMontAndYearGSTR, setToMontAndYearGSTR] = useState("");

  // New states for improved loading experience
  const [isProcessing, setIsProcessing] = useState(false);
  const [processingMessage, setProcessingMessage] = useState("");
  const eventSourceRef = useRef(null);
  const sseOpenedRef = useRef(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const handleBack = () => {
    history.push("/reconCards");
  };

  const handleSnackbarOpen = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const title = "GSTR-6a";
  const url = "gstr6a";

  const handleOpenAndCloseModel = () => {
    setOpenAndCloseModel(!openAndCloseModel);
    setForDisplayingToMonthAndYear("");
    setForDisplayingFromMonthAndYear("");
    setFromMonthAndYear("");
    setToMontAndYear("");
    setRoundValue(0);
    setCustomRoundOff("");
    setTrigarCustomRoundOff(false);
    setForDisplayingFromMonthAndYearGSTR("");
    setForDisplayingToMonthAndYearGSTR("");
    setToMontAndYearGSTR("");
    setFromMonthAndYearGSTR("");
    setChecked(false);
  };

  const setFromYearValues = () => {
    let current_year = new Date().getFullYear();
    let yearArr1 = [];
    for (let i = current_year - 7; i <= current_year + 5; i++) {
      let startYear = i;
      let endYear = i + 1;
      let endYearShort = endYear.toString().slice(-2);
      yearArr1.push({
        id: `${startYear}-${endYearShort}`,
        value: `${startYear}-${endYearShort}`,
      });
    }
  };

  const inputHandlerForYearAndFromMonth = (v) => {
    setForDisplayingFromMonthAndYear(v);
    const current_date = new Date(v);
    const yy = current_date.getFullYear().toString();
    const mm = (current_date.getMonth() + 1).toString();

    let MonthAndYear;
    if (mm < 10) {
      MonthAndYear = `0${mm}${yy}`;
    } else {
      MonthAndYear = `${mm}${yy}`;
    }
    setFromMonthAndYear(MonthAndYear);
  };

  const inputHandlerForYearAndToMonth = (v) => {
    setForDisplayingToMonthAndYear(v);
    const current_date = new Date(v);
    const yy = current_date.getFullYear().toString();
    const mm = (current_date.getMonth() + 1).toString();

    let toMonthAndYear;
    if (mm < 10) {
      toMonthAndYear = `0${mm}${yy}`;
    } else {
      toMonthAndYear = `${mm}${yy}`;
    }
    setToMontAndYear(toMonthAndYear);
  };

  const inputHandlerForYearAndFromMonthGSTR = (v) => {
    setForDisplayingFromMonthAndYearGSTR(v);
    const current_date = new Date(v);
    const yy = current_date.getFullYear().toString();
    const mm = (current_date.getMonth() + 1).toString();

    let MonthAndYear;
    if (mm < 10) {
      MonthAndYear = `0${mm}${yy}`;
    } else {
      MonthAndYear = `${mm}${yy}`;
    }
    setFromMonthAndYearGSTR(MonthAndYear);
  };

  const inputHandlerForYearAndToMonthGSTR = (v) => {
    setForDisplayingToMonthAndYearGSTR(v);
    const current_date = new Date(v);
    const yy = current_date.getFullYear().toString();
    const mm = (current_date.getMonth() + 1).toString();

    let toMonthAndYear;
    if (mm < 10) {
      toMonthAndYear = `0${mm}${yy}`;
    } else {
      toMonthAndYear = `${mm}${yy}`;
    }
    setToMontAndYearGSTR(toMonthAndYear);
  };

  const handleChangeCheckbox = () => {
    setChecked(!checked);
  };

  const roundValueInputHandler = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (name === "threshold_value" && value === 11) {
      setRoundValue(value);
      setTrigarCustomRoundOff(!trigarCustomRoundOff);
    } else if (name === "threshold_value") {
      setRoundValue(value);
      setTrigarCustomRoundOff(false);
    } else if (name === "customRoundOff") {
      setCustomRoundOff(value);
    }
  };


  const initiateReconSSE = (sseToken) => {
    return new Promise((resolve, reject) => {
      if (eventSourceRef.current) {
        eventSourceRef.current.close();
        eventSourceRef.current = null;
    }

      console.log("SSE Starting point");
      sseOpenedRef.current = false;

      const sseUrl = `${SSE_BASE_URL}/api/sse/${sseToken}`;
      const es = new EventSource(sseUrl);
      eventSourceRef.current = es;

      console.log("SSE object created:", sseUrl, "readyState:", es.readyState);

      es.onopen = () => {
        sseOpenedRef.current = true;
        console.log('SSE onopen fired, readyState:', es.readyState);
        resolve();
  };

      es.onmessage = (event) => {
        console.log("RAW SSE:", event.data);
        try {
          const data = JSON.parse(event.data);
          console.log("REAL SSE DATA:", data);
          if (data.status === "done" || data.status === "Pass") {
            if (eventSourceRef.current) {
              eventSourceRef.current.close();
              eventSourceRef.current = null;
            }
            const reconId = data.recon_id || data.gstr6a_recon_id;
            fetchAndRedirect(reconId);
          }
        } catch (err) {
          console.log("Ignoring non-json SSE message:", event.data);
        }
      };

      es.onerror = (e) => {
        const rs = eventSourceRef.current?.readyState;
        console.log("SSE onerror fired, readyState:", rs);
        if (rs === 2) {
          if (eventSourceRef.current) {
            eventSourceRef.current.close();
            eventSourceRef.current = null;
          }
          if (!sseOpenedRef.current) {
            reject(new Error("SSE connection failed permanently"));
          }
        }
      };
    });
  };

  const fetchAndRedirect = (reconId) => {
    console.log("fetchAndRedirect called with:", reconId);
    if (!reconId) {
      setIsProcessing(false);
      setProcessingMessage('');
      setLoaderForTable(false);
      handleSnackbarOpen('No recon ID received from SSE.', 'error');
      return;
    }

    axios
      .get(`/gstr6a/summary/${reconId}`)
      .then((res) => {
        if (res.data.status && res.data.record) {
          setIsProcessing(false);
          setProcessingMessage('');
          setLoaderForTable(false);
          handleSnackbarOpen(`${title} Reconciliation completed! Redirecting...`, "success");
          setTimeout(() => {
            redirectToReport(reconId);
          }, 1000);
        } else {
          setIsProcessing(false);
          setProcessingMessage('');
          setLoaderForTable(false);
          handleSnackbarOpen('Failed to fetch report. Please refresh.', 'error');
        }
      })
      .catch(() => {
        setIsProcessing(false);
        setProcessingMessage('');
        setLoaderForTable(false);
        handleSnackbarOpen('Error loading report data.', 'error');
      });
  };

  const redirectToReport = (reconId) => {
    const encrypt = (text) => {
      return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(text));
    };

    history.push({
      pathname: `/${url}ReconciliationReport/${encrypt(reconId)}`,
      state: {
        v: reconId,
        url,
      },
    });
  };

  const runNewReconciliation = async () => {
    const org_gstin = localStorage.getItem("gst");

    try {
      setLoaderForTable(true);
      setIsProcessing(true);
      // setProcessingMessage('Opening SSE connection...');
    handleSnackbarOpen("Initiating new reconciliation...", "info");

      const sseToken = generateUUID();

      // STEP 1 — Wait until SSE actually opens
      await initiateReconSSE(sseToken);
      console.log('SSE confirmed open. Starting recon POST.');
      setProcessingMessage('Reconciliation is Running.');

    const reconPayload = {
      org_gstin: org_gstin,
      report_type: "gstr6a",
      period_type: "previous_month",
      threshold_value: 5,
      business_entity_id: localStorage.getItem("business_entity_id"),
        sse_token: sseToken,
        functionality: 'GSTR6A Recon', 
    };

      // STEP 2 — Start recon only AFTER SSE is open
      const reconResponse = await axios.post("/unified_auto_reconciliation", reconPayload);
      console.log('Recon API response:', reconResponse.data);

      if (!reconResponse.data || reconResponse.data.status === false) {
        if (eventSourceRef.current) { eventSourceRef.current.close(); eventSourceRef.current = null; }
        setIsProcessing(false);
        setProcessingMessage('');
        setLoaderForTable(false);
        handleSnackbarOpen(reconResponse.data?.message || "Failed to initiate reconciliation", "error");
        return;
      }

      handleSnackbarOpen("Reconciliation is Running", "info");

    } catch (error) {
      if (eventSourceRef.current) { eventSourceRef.current.close(); eventSourceRef.current = null; }
      setIsProcessing(false);
      setProcessingMessage('');
      setLoaderForTable(false);
      handleSnackbarOpen(
        error.response?.data?.message || error.message || "Error initiating reconciliation",
        "error"
      );
    }
  };

  const checkReconciliationAndRedirect = async (reconId) => {
    const summaryUrl = `/gstr6a/summary/${reconId}`;

    try {
      const summaryResponse = await axios.get(summaryUrl);

      if (summaryResponse.data.status === true) {
        const recordData =
          summaryResponse.data.record || summaryResponse.data.data || {};
        const entityDetails = recordData.entity_details || {};
        const reconStatus =
          entityDetails.recon_status ||
          recordData.status ||
          recordData.recon_status;
        const statusLower = String(reconStatus).toLowerCase();

        if (statusLower === "pass" || statusLower === "completed") {
          handleSnackbarOpen("Loading report", "success");
          setTimeout(() => {
            redirectToReport(reconId);
          }, 500);
        } else if (
          statusLower === "processing" ||
          statusLower === "initiated" ||
          statusLower === "inprogress" ||
          statusLower === "in progress"
        ) {
          handleSnackbarOpen("Processing reconciliation... Please wait.", "info");
          setLoaderForTable(false);
          redirectToReport(reconId);
        } else if (statusLower === "fail") {
          setLoaderForTable(false);
          handleSnackbarOpen("Reconciliation failed", "error");
        } else {
          setLoaderForTable(false);
          handleSnackbarOpen("Reconciliation data not ready yet", "warning");
        }
      } else {
        throw new Error("Summary validation failed");
      }
    } catch (error) {
      console.error("Summary API error:", error);
      throw new Error("Failed to validate existing record");
    }
  };

  useEffect(() => {
    const initializeComponent = async () => {
      const business_entity_id = localStorage.getItem("business_entity_id");
      const org_gstin =
        localStorage.getItem("gstin") || localStorage.getItem("gst");

      if (!business_entity_id || !org_gstin) {
        handleSnackbarOpen(
          "Missing business entity or GSTIN information",
          "error",
        );
        setLoaderForTable(false);
        return;
      }

      const payload = {
        business_entity_id: parseInt(business_entity_id),
        org_gstin: org_gstin,
        report_type: "gstr6a",
      };

      setLoaderForTable(true);
      handleSnackbarOpen(`Loading ${title} reconciliation data`, "info");

      try {
        const latestRecordsResponse = await axios.post(
          "/get_latest_recon_records",
          payload,
        );

        if (
          latestRecordsResponse.data.status &&
          latestRecordsResponse.data.data?.recon_id
        ) {
          const reconId = latestRecordsResponse.data.data.recon_id;
          await checkReconciliationAndRedirect(reconId);
        } else if (
          latestRecordsResponse.data.status === false ||
          !latestRecordsResponse.data.data?.recon_id
        ) {
          await runNewReconciliation();
        }
      } catch (error) {
        console.error("Error in initialization:", error);
        try {
          await runNewReconciliation();
        } catch (fallbackError) {
          console.error("Error in fallback reconciliation:", fallbackError);
          setLoaderForTable(false);
          handleSnackbarOpen(
            fallbackError.response?.data?.message ||
              fallbackError.message ||
              "Error loading reconciliation",
            "error",
          );
        }
      }
    };

    initializeComponent();
    setFromYearValues();

    return () => {
      if (eventSourceRef.current) {
        eventSourceRef.current.close();
        eventSourceRef.current = null;
      }
    };
  }, []);

  const getApiForGstr6aRecon = () => {
    setLoaderForTable(true);

    axios
      .get(`/${url}_recon_list`, {
        params: {
          org_gstin: localStorage.getItem("gst"),
          business_entity_id: localStorage.getItem("business_entity_id"),
        },
      })
      .then((res) => {
        setLoaderForTable(false);
        if (res.data.status === true) {
        } else {
          handleSnackbarOpen(res.data.message || "No records found", "warning");
        }
      })
      .catch((err) => {
        setLoaderForTable(false);
        console.error("Error fetching reconciliation data:", err);
        handleSnackbarOpen(
          "Failed to fetch reconciliation data. Please try again later.",
          "error",
        );
      });
  };

  const onSubmitHandler = async () => {
    let roundValueData;
    if (roundValue === "11") roundValueData = `${customRoundOff}`;
    else roundValueData = `${roundValue}`;

    handleOpenAndCloseModel();

    try {
      setLoaderForTable(true);
      setIsProcessing(true);
      // setProcessingMessage('Opening SSE connection...');
      handleSnackbarOpen("Initiating reconciliation...", "info");

      const sseToken = generateUUID();

      // STEP 1 — Wait until SSE actually opens
      await initiateReconSSE(sseToken);
      console.log('SSE confirmed open. Starting recon POST.');
      setProcessingMessage('Custom Reconciliation is Running. ');

      const payload = {
        org_gstin: localStorage.getItem("gst"),
        books_from_tax_period: fromMonthAndYear,
        books_to_tax_period: toMontAndYear,
        gstr_from_tax_period: checked ? fromMonthAndYearGSTR : fromMonthAndYear,
        gstr_to_tax_period: checked ? toMontAndYearGSTR : toMontAndYear,
        tval: roundValueData,
        business_entity_id: localStorage.getItem("business_entity_id"),
        period_type: "custom",
        report_type: "gstr6a",
        sse_token: sseToken,
        functionality: 'GSTR6A Recon', 
      };

      // STEP 2 — Start recon only AFTER SSE is open
      const res = await axios.post(`/unified_auto_reconciliation`, payload);
      console.log('Recon API response:', res.data);

      if (!res.data || res.data.status === false) {
        if (eventSourceRef.current) { eventSourceRef.current.close(); eventSourceRef.current = null; }
        setIsProcessing(false);
        setProcessingMessage('');
        setLoaderForTable(false);
        handleSnackbarOpen(res.data?.message || "Failed to initiate reconciliation", "error");
        return;
      }

      handleSnackbarOpen("Reconciliation is Running", "info");
      // Result arrives via SSE → fetchAndRedirect → redirectToReport

    } catch (err) {
      if (eventSourceRef.current) { eventSourceRef.current.close(); eventSourceRef.current = null; }
      setIsProcessing(false);
      setProcessingMessage('');
      setLoaderForTable(false);
      handleSnackbarOpen("An error occurred. Please try again later!", "error");
    }
  };

  const renderGSTR6aReconModel = () => {
    return (
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={openAndCloseModel}
        onHide={handleOpenAndCloseModel}
        dialogClassName="modal-50w"
      >
        <Modal.Header closeButton>
          <Modal.Title>{title} Reconciliation</Modal.Title>
        </Modal.Header>
        <ValidatorForm
          useRef="form"
          onSubmit={onSubmitHandler}
          onError={(errors) => console.log(errors)}
        >
          <Modal.Body>
            <Grid item sm={12} container>
              <Checkbox checked={checked} onChange={handleChangeCheckbox} />
              <p
                onClick={handleChangeCheckbox}
                style={{
                  marginTop: "10px",
                  fontSize: "16px",
                  cursor: "pointer",
                }}
              >
                Advanced Criteria
              </p>
            </Grid>
            <Grid container spacing={1}>
              {checked && (
                <Grid item sm={12}>
                  <p style={{ marginTop: "14px", fontSize: "16px" }}>
                    Books Period :
                  </p>
                </Grid>
              )}
              <Grid item sm={2}>
                <p style={{ marginTop: "14px", fontSize: "16px" }}>
                  From Month<span style={{ color: "red" }}>*</span>:
                </p>
              </Grid>
              <Grid item sm={4}>
                <div style={{ marginTop: "10px" }}>
                  <ValidatedDatePicker
                    placeholder="Month & Year"
                    errorMessages={["This field is required"]}
                    validators={["required"]}
                    value={forDisplayingFromMonthAndYear}
                    onChange={(v) => inputHandlerForYearAndFromMonth(v)}
                  />
                </div>
              </Grid>
              <Grid item sm={2}>
                <p style={{ marginTop: "14px", fontSize: "16px" }}>
                  To Month<span style={{ color: "red" }}>*</span>:
                </p>
              </Grid>
              <Grid item sm={4}>
                <div style={{ marginTop: "10px" }}>
                  <ValidatedMonthAndYearPicker
                    minDateForDatepicker={forDisplayingFromMonthAndYear}
                    errorMessages={["This field is required"]}
                    validators={["required"]}
                    placeholder="Month & Year"
                    value={forDisplayingToMonthAndYear}
                    onChange={(v) => inputHandlerForYearAndToMonth(v)}
                  />
                </div>
              </Grid>

              {checked && (
                <Grid item sm={12}>
                  <p style={{ marginTop: "14px", fontSize: "16px" }}>
                    {title} Period :
                  </p>
                </Grid>
              )}

              {checked && (
                <>
                  <Grid item sm={2}>
                    <p style={{ marginTop: "14px", fontSize: "16px" }}>
                      From Month<span style={{ color: "red" }}>*</span>:
                    </p>
                  </Grid>

                  <Grid item sm={4}>
                    <div style={{ marginTop: "10px" }}>
                      <ValidatedDatePicker
                        placeholder="Month & Year"
                        errorMessages={["This field is required"]}
                        validators={["required"]}
                        value={forDisplayingFromMonthAndYearGSTR}
                        onChange={(v) => inputHandlerForYearAndFromMonthGSTR(v)}
                      />
                    </div>
                  </Grid>

                  <Grid item sm={2}>
                    <p style={{ marginTop: "14px", fontSize: "16px" }}>
                      To Month<span style={{ color: "red" }}>*</span>:
                    </p>
                  </Grid>

                  <Grid item sm={4}>
                    <div style={{ marginTop: "10px" }}>
                      <ValidatedMonthAndYearPicker
                        minDateForDatepicker={forDisplayingFromMonthAndYearGSTR}
                        errorMessages={["This field is required"]}
                        validators={["required"]}
                        placeholder="Month & Year"
                        value={forDisplayingToMonthAndYearGSTR}
                        onChange={(v) => inputHandlerForYearAndToMonthGSTR(v)}
                      />
                    </div>
                  </Grid>
                </>
              )}

              <Grid item sm={2}>
                <p style={{ marginTop: "6px", fontSize: "16px" }}>
                  Threshold value<span style={{ color: "red" }}>*</span>:
                </p>
              </Grid>
              <Grid item sm={10}>
                <SelectField
                  validator={["required"]}
                  errorMsg={["This field is required"]}
                  choice_id="id"
                  choice_name="roundOff"
                  name="threshold_value"
                  value={roundValue ?? 0}
                  choices={[
                    { id: 0, roundOff: "No Threshold Value" },
                    { id: 1, roundOff: "Upto 1" },
                    { id: 5, roundOff: "Upto 5" },
                    { id: 10, roundOff: "Upto 10" },
                    { id: 11, roundOff: "Custom" },
                  ]}
                  textOnchangeFunction={roundValueInputHandler}
                />
              </Grid>
            </Grid>
            {trigarCustomRoundOff ? (
              <>
                <div className={designForGstr2b.monthstyle}>
                  <Grid container spacing={3}>
                    <Grid item sm={3}>
                      <p style={{ marginTop: "30px", fontSize: "16px" }}>
                        Custom Round off
                        <span style={{ color: "red" }}>*</span> :
                      </p>
                    </Grid>
                    <Grid item sm={9}>
                      <BasicInputField
                        inputType="number"
                        name="customRoundOff"
                        validator={["required"]}
                        errorMsg={["This field is required"]}
                        value={customRoundOff ?? ""}
                        textOnchangeFunction={roundValueInputHandler}
                      />
                    </Grid>
                  </Grid>
                </div>
              </>
            ) : (
              ""
            )}
          </Modal.Body>
          <Modal.Footer>
            <div>
              <button className="button-primary" type="submit">
                Submit
              </button>
              <button
                className="button-outlined-secondary"
                type="button"
                onClick={handleOpenAndCloseModel}
              >
                Cancel
              </button>
            </div>
          </Modal.Footer>
        </ValidatorForm>
      </Modal>
    );
  };

  return (
    <>
      {renderGSTR6aReconModel()}

      {loaderForTable && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "60vh",
            padding: "20px",
          }}
        >
          <Tooltip title="Back" arrow>
            <IconButton
              onClick={handleBack}
              sx={{
                position: "absolute",
                top: "20px",
                left: "20px",
                borderRadius: "50%",
                padding: "6px",
                color: "#263238",
                fontSize: "20px",
                backgroundColor: "#ffffff",
                height: "36px",
                width: "36px",
                "&:hover": {
                  backgroundColor: "#455a64",
                  color: "#ffffff",
                },
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                transition: "background-color 0.3s ease",
              }}
            >
              <ArrowBackIcon sx={{ fontSize: "20px" }} />
            </IconButton>
          </Tooltip>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "20px",
            }}
          >
            <CircularProgress size={60} />
            <div
              style={{
                textAlign: "center",
                fontSize: "18px",
                color: "#263238",
                fontWeight: "bold",
              }}
            >
              {isProcessing
                ? processingMessage || `Processing ${title} Reconciliation...`
                : `Loading ${title} Reconciliation Report`}
            </div>
            <div
              style={{
                fontSize: "14px",
                color: "#666",
                textAlign: "center",
                maxWidth: "400px",
              }}
            >
              Please wait while we prepare your reconciliation report. This may
              take a few moments.
            </div>
          </div>
        </div>
      )}

      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}
